/* eslint-disable max-len */
import React from 'react';

const Link: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_10160_4277)">
      <path d="M8.33338 10.834C8.69125 11.3124 9.14784 11.7083 9.67217 11.9947C10.1965 12.2812 10.7763 12.4516 11.3723 12.4942C11.9682 12.5369 12.5664 12.4509 13.1262 12.2421C13.686 12.0333 14.1943 11.7065 14.6167 11.284L17.1167 8.78396C17.8757 7.99811 18.2957 6.9456 18.2862 5.85312C18.2767 4.76063 17.8385 3.71558 17.066 2.94304C16.2934 2.17051 15.2484 1.73231 14.1559 1.72281C13.0634 1.71332 12.0109 2.1333 11.225 2.89229L9.79171 4.31729M11.6667 9.16729C11.3088 8.68885 10.8522 8.29297 10.3279 8.00651C9.80359 7.72004 9.22379 7.54969 8.62784 7.50701C8.03188 7.46433 7.43372 7.55032 6.87392 7.75914C6.31412 7.96796 5.80578 8.29473 5.38338 8.71729L2.88338 11.2173C2.12439 12.0031 1.70441 13.0556 1.7139 14.1481C1.7234 15.2406 2.1616 16.2857 2.93413 17.0582C3.70667 17.8307 4.75172 18.2689 5.84421 18.2784C6.93669 18.2879 7.9892 17.8679 8.77504 17.109L10.2 15.684" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_10160_4277">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Link;
